import { getState } from '@hotjar/webapp/domains/activation/tracking-code';

/**
 * Services for checking if the script has been installed.
 */
angular.module('hjApp.account').service('TrackingCode', function () {
    /*******************
     * PUBLIC FUNCTIONS
     *****************/
    /**
     * Get the state of the tracking code for a site.
     */
    this.getState = (site) => getState(site?.last_data);
});
